import React, { Component } from "react";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect } from "react-router-dom";
import Card from "components/Card/Card.js";
import EditIcon from "@material-ui/icons/Edit";
import CardHeader from "components/Card/CardHeader.js";
import axios from "axios";
import Loader from "components/Loader";
import CardIcon from "components/Card/CardIcon.js";
import Constants from "../variables/Constants";
import CardBody from "components/Card/CardBody.js";
import AddAlert from "@material-ui/icons/AddAlert";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";

class ServicesText extends Component {
  state = {
    heading: "",
    expertFaculty: "",
    digitalLearning: "",
    easyLearning: "",
    freeStudyMaterial: "",
    redirect: false,
    notification: false,
    loading: false
  };
  componentDidMount() {
    axios.get(Constants.getUrls.servicesText).then(resp => {
      //console.log(resp.data);
      this.setState({
        heading: resp.data.CONTENT,
        expertFaculty: resp.data.CONTENT_1,
        digitalLearning: resp.data.CONTENT_2,
        easyLearning: resp.data.CONTENT_3,
        freeStudyMaterial: resp.data.CONTENT_4
      });
    });
  }
  handleSubmit = e => {
    this.setState({
      loading: true
    });
    e.preventDefault();
    let payLoad = {
      content: this.state.heading,
      content_1: this.state.expertFaculty,
      content_2: this.state.digitalLearning,
      content_3: this.state.easyLearning,
      content_4: this.state.freeStudyMaterial
    };
    axios.post(Constants.postUrls.updateServicesText, payLoad).then(() => {
      //console.log(resp);
      setTimeout(() => {
        this.setState({
          notification: false
        });
      }, 1000);
      this.setState({
        notification: true,
        loading: false
      });
    });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/categories"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Content Updated!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Services Text</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Heading"
                          inputProps={{
                            value: this.state.heading,
                            onChange: e =>
                              this.setState({ heading: e.target.value }, () => {
                                //console.log(this.state.heading);
                              })
                          }}
                          id="float"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Expert Faculty"
                          inputProps={{
                            value: this.state.expertFaculty,
                            onChange: e =>
                              this.setState(
                                { expertFaculty: e.target.value },
                                () => {
                                  //console.log(this.state.expertFaculty);
                                }
                              )
                          }}
                          id="float"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Digital Learning"
                          inputProps={{
                            value: this.state.digitalLearning,
                            onChange: e =>
                              this.setState(
                                { digitalLearning: e.target.value },
                                () => {
                                  //console.log(this.state.digitalLearning);
                                }
                              )
                          }}
                          id="float"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Easy Learning"
                          inputProps={{
                            value: this.state.easyLearning,
                            onChange: e =>
                              this.setState(
                                { easyLearning: e.target.value },
                                () => {
                                  //console.log(this.state.easyLearning);
                                }
                              )
                          }}
                          id="float"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Free Study Material"
                          inputProps={{
                            value: this.state.freeStudyMaterial,
                            onChange: e =>
                              this.setState(
                                { freeStudyMaterial: e.target.value },
                                () => {
                                  //console.log(this.state.freeStudyMaterial);
                                }
                              )
                          }}
                          id="float"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <Button className="" type="submit" color="info">
                        {this.state.loading ? (
                          <Loader />
                        ) : (
                          "Update Services Text"
                        )}
                      </Button>
                    </GridItem>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default ServicesText;
